import { render, staticRenderFns } from "./activity-session-container.vue?vue&type=template&id=2a85357d&scoped=true&"
import script from "./activity-session-container.ts?vue&type=script&lang=ts&"
export * from "./activity-session-container.ts?vue&type=script&lang=ts&"
import style0 from "./activity-session-container.scss?vue&type=style&index=0&id=2a85357d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a85357d",
  null
  
)

export default component.exports